var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7668 4.42857H1.8595V15.8571C1.8595 16.4883 2.30376 17 2.85177 17H12.7745C13.3225 17 13.7668 16.4883 13.7668 15.8571V4.42857Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83632 3.85714V2.14286C4.83632 1.51167 5.28057 1 5.82859 1H9.79767C10.3457 1 10.7899 1.51167 10.7899 2.14286V3.85714M0.371094 4.42857H15.2552M1.8595 4.42857V15.8571C1.8595 16.4883 2.30376 17 2.85177 17H12.7745C13.3225 17 13.7668 16.4883 13.7668 15.8571V4.42857M7.81313 8.42857V14.1429M4.83632 10.7143V12.4286V14.1429M10.7899 10.7143V14.1429",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81275 8.42969V14.144M4.83594 10.7154V12.4297V14.144M10.7896 10.7154V14.144",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashFill);
export default __webpack_public_path__ + "static/media/trash-fill.708058b309bfb0449da612e3c3bdab21.svg";
export { ForwardRef as ReactComponent };